module.exports = __webpack_public_path__ + "img/flogstad_Portrett2.d7204577.jpg";